// Автоматически сгенерировано. Не редактировать!
const DialogComponentCss = `.dialog-backdrop {
  width: var(--dialog-backdrop-width, 100%);
  height: var(--dialog-backdrop-height, 100%);
  position: fixed;
  z-index: var(--dialog-backdrop-zindex, 1000);
  inset: 0;
  background: var(--dialog-backdrop-bg, rgba(0, 0, 0, 0.4));
  transition: opacity 0.3s;
  left: var(--dialog-backdrop-left, 0);
  top: var(--dialog-backdrop-top, 0);
  bottom: var(--dialog-backdrop-bottom);
  right: var(--dialog-backdrop-right);
}
.dialog-backdrop[hidden] {
  opacity: 0;
  pointer-events: none;
}
/* 2026-08-30: DialogComponent наследует семантические токены страницы через host,
   поэтому встроенный fallback поддерживает светлую и тёмную темы без отдельного шаблона. */
.dialog {
  width: var(--dialog-width, max-content);
  min-width: var(--dialog-min-width, 250px);
  max-width: var(--dialog-max-width, 98vw);
  height: var(--dialog-height);
  min-height: var(--dialog-min-height, 120px);
  max-height: var(--dialog-max-height, 98vh);
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: var(--dialog-bg, var(--color-bg-raised, white));
  color: var(--dialog-color, var(--color-text-default, black));
  border-radius: var(--dialog-border-radius, 6px);
  box-shadow: var(--dialog-shadow, var(--elevation-high, 0 2px 12px rgba(0, 0, 0, 0.2)));
  z-index: calc(1 + var(--dialog-backdrop-zindex, 1001));
  outline: none;
}
.dialog.progress {
  --dialog-width: 600px;
}
.dialog[hidden] {
  display: none !important;
}
.dialog-header {
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top-left-radius: var(--dialog-border-radius, 6px);
  border-top-right-radius: var(--dialog-border-radius, 6px);
  padding: var(--dialog-header-padding, 8px 16px);
  background: var(--dialog-header-bg, inherit);
  user-select: none;
  gap: var(--dialog-header-gap, 8px);
  cursor: var(--dialog-header-cursor, move);
  pointer-events: var(--dialog-header-pointer-events);
}
.dialog-title-wrapper {
  max-width: calc(100% - 56px);
  display: flex;
  align-items: center;
  gap: var(--dialog-title-gap, var(--dialog-header-gap, 8px));
}
.dialog-title {
  font-size: var(--dialog-title-fs, 20px);
  font-weight: var(--dialog-title-fw, 600);
  font-family: var(--dialog-title-ff, inherit);
  color: var(--dialog-title-color, inherit);
  white-space: var(--dialog-title-white-space, normal);
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
}
.dialog-close {
  background: transparent;
  border: none;
  cursor: pointer;
  transition: var(--dialog-close-transition);
  transform: var(--dialog-close-transform);
  pointer-events: var(--dialog-close-pointer-events);
}
.dialog-close svg,
.dialog-close svg path {
  fill: var(--dialog-close-svg-fill, var(--color-icon-default, black));
  transition: 0.3s fill;
}
.dialog-close:hover {
  transform: var(--dialog-close-transform-hover);
}
.dialog-close:hover svg,
.dialog-close:hover svg path {
  fill: var(--dialog-close-svg-fill-hover, var(--color-icon-disabled, rgba(0, 0, 0, 0.5)));
}
.dialog-close:active {
  transform: var(--dialog-close-transform-active);
}
.dialog-body {
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  max-width: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  padding: var(--dialog-body-padding, 0 16px);
  margin: var(--dialog-body-margin, 16px 0);
  overflow: auto;
}
slot[name="content"]::slotted(*) {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  max-height: 100%;
  max-width: 100%;
  min-height: 0;
  min-width: 0;
}
.dialog-footer {
  flex-shrink: 0;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding: var(--dialog-footer-padding, 0 16px 16px);
}
/* 2026-10-13: иконка — маска по popup-*.svg, цвет из --dialog-icon-color-<тип> / --dialog-icon-color.
   Белые SVG фоном не перекрасить, и на светлой шапке темы (--dialog-bg-* на subtle-токенах) они пропадали.
   SVG одноцветные (white + opacity), поэтому маска сохраняет рисунок; без переменных — белый, как раньше. */
.dialog-icon {
  width: var(--dialog-icon-size, 24px);
  height: var(--dialog-icon-size, 24px);
  display: block;
  background-color: var(--dialog-icon-color, white);
  mask-position: center;
  mask-repeat: no-repeat;
  mask-size: contain;
}
.dialog-icon-error {
  mask-image: url('/src/vs/img/popup-error.svg');
  background-color: var(--dialog-icon-color-error, var(--dialog-icon-color, white));
}
.dialog-icon-warning {
  mask-image: url('/src/vs/img/popup-alert.svg');
  background-color: var(--dialog-icon-color-warning, var(--dialog-icon-color, white));
}
.dialog-icon-success {
  mask-image: url('/src/vs/img/popup-check.svg');
  background-color: var(--dialog-icon-color-success, var(--dialog-icon-color, white));
}
.dialog-icon-info {
  mask-image: url('/src/vs/img/popup-input.svg');
  background-color: var(--dialog-icon-color-info, var(--dialog-icon-color, white));
}
.dialog-icon-question {
  mask-image: url('/src/vs/img/popup-question.svg');
  background-color: var(--dialog-icon-color-question, var(--dialog-icon-color, white));
}
.dialog-alert {
  /* 2026-10-07: на телефоне длинный вопрос растягивал окно (width: max-content) до 600px за край экрана. */
  max-width: min(600px, var(--dialog-max-width, 98vw));
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.dialog-alert-warning .dialog-header {
  background-color: var(--dialog-bg-warning, hsl(var(--orange-h, 40), var(--orange-s, 90%), var(--orange-l, 66%)));
}
.dialog-alert-success .dialog-header {
  background-color: var(--dialog-bg-success, hsl(var(--green-h, 150), var(--green-s, 90%), var(--green-l, 40%)));
}
.dialog-alert-info .dialog-header {
  background-color: var(--dialog-bg-info, hsl(var(--blue-h, 200), var(--blue-s, 64%), var(--blue-l, 48%)));
}
.dialog-alert-error .dialog-header {
  background-color: var(--dialog-bg-error, hsl(var(--red-h, 354), var(--red-s, 90%), var(--red-l, 64%)));
}
.dialog-alert-question .dialog-header {
  background-color: var(--dialog-bg-question, hsl(var(--blue-h, 200), var(--blue-s, 64%), var(--blue-light-l, 72%)));
}
.dialog-alert .dialog-header {
  justify-content: flex-start;
}
/* 2026-10-13: цвет заголовка alert-окна берётся из --dialog-title-color: тема со светлой шапкой
   (--dialog-bg-* на subtle-токенах) иначе получала белый текст на светлом фоне. Без переменной — белый, как раньше. */
.dialog-alert .dialog-title {
  font-size: 16px;
  font-weight: normal;
  color: var(--dialog-title-color, white);
}
.dialog-alert .dialog-body {
  text-align: center;
}
.dialog-alert .dialog-alert-text {
  /*
        Криво показывает текст если там вставлены теги    
        display: flex;
        align-items: center;
        justify-content: center;*/
  min-height: 30px;
}
.dialog-alert .dialog-footer {
  justify-content: center;
}
`;
const DialogComponentHtml = `<div class="dialog-backdrop" part="backdrop" hidden></div>
<div class="dialog">
    <div class="dialog-header">
        <slot name="header">
            <div class="dialog-title-wrapper">
                <span class="dialog-title"></span>
            </div>
        </slot>
        <button class="dialog-close" aria-label="">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 4L4 12" stroke="#0F3243" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M4 4L12 12" stroke="#0F3243" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>
    </div>
    <div class="dialog-body">
        <slot name="content"></slot>
    </div>
    <div class="dialog-footer">
        <slot name="footer"></slot>
    </div>
</div>
`;

export { DialogComponentCss, DialogComponentHtml };
